import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS
export const PACKETBOX_FETCH_REQUEST = 'packetboxes/PACKETBOX_FETCH_REQUEST';
export const PACKETBOX_FETCH_SUCCESS = 'packetboxes/PACKETBOX_FETCHED_SUCCESS';
export const PACKETBOX_FETCH_ERROR = 'packetboxes/PACKETBOX_FETCHED_ERROR';

export const PACKETBOXES_FETCH_REQUEST = 'packetboxes/PACKETBOXES_FETCH_REQUEST';
export const PACKETBOXES_FETCH_SUCCESS = 'packetboxes/PACKETBOXES_FETCHED_SUCCESS';
export const PACKETBOXES_FETCH_ERROR = 'packetboxes/PACKETBOXES_FETCHED_ERROR';

export const PACKETBOX_CREATE_REQUEST = 'packetboxes/PACKETBOX_CREATE_REQUEST';
export const PACKETBOX_CREATE_SUCCESS = 'packetboxes/PACKETBOX_CREATE_SUCCESS';
export const PACKETBOX_CREATE_ERROR = 'packetboxes/PACKETBOX_CREATE_ERROR';

export const PACKETBOX_MODIFY_REQUEST = 'packetboxes/PACKETBOX_MODIFY_REQUEST';
export const PACKETBOX_MODIFY_SUCCESS = 'packetboxes/PACKETBOX_MODIFY_SUCCESS';
export const PACKETBOX_MODIFY_ERROR = 'packetboxes/PACKETBOX_MODIFY_ERROR';

export const NOTES_FETCH_REQUEST = 'packetboxes/NOTES_FETCH_REQUEST';
export const NOTES_FETCH_SUCCESS = 'packetboxes/NOTES_FETCH_SUCCESS';
export const NOTES_FETCH_ERROR = 'packetboxes/NOTES_FETCH_ERROR';

export const NOTE_CREATE_REQUEST = 'packetboxes/NOTE_CREATE_REQUEST';
export const NOTE_CREATE_SUCCESS = 'packetboxes/NOTE_CREATE_SUCCESS';
export const NOTE_CREATE_ERROR = 'packetboxes/NOTE_CREATE_ERROR';

export const NOTE_MODIFY_REQUEST = 'packetboxes/NOTE_MODIFY_REQUEST';
export const NOTE_MODIFY_SUCCESS = 'packetboxes/NOTE_MODIFY_SUCCESS';
export const NOTE_MODIFY_ERROR = 'packetboxes/NOTE_MODIFY_ERROR';

export const PACKETBOX_UNLOAD_CURRENT = 'packetboxes/PACKETBOX_UNLOAD_CURRENT';

export const PACKETBOX_KEYS_FETCH_REQUEST = 'packetboxes/PACKETBOX_KEYS_FETCH_REQUEST';
export const PACKETBOX_KEYS_FETCH_SUCCESS = 'packetboxes/PACKETBOX_KEYS_FETCH_SUCCESS';
export const PACKETBOX_KEYS_FETCH_ERROR = 'packetboxes/PACKETBOX_KEYS_FETCH_ERROR';

export const PACKETBOX_REGENERETE_TAN_REQUEST = 'packetboxes/PACKETBOX_REGENERETE_TAN_REQUEST';
export const PACKETBOX_REGENERETE_TAN_SUCCESS = 'packetboxes/PACKETBOX_REGENERETE_TAN_SUCCESS';
export const PACKETBOX_REGENERETE_TAN_ERROR = 'packetboxes/PACKETBOX_REGENERETE_TAN_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    currentKeys: null,
    fetching: false,
    fetched: false,
    error: null,
    tanRegenerating: false,
  },
  action
) {
  switch (action.type) {
    case PACKETBOXES_FETCH_REQUEST:
    case PACKETBOX_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case PACKETBOXES_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        entities: action.payload.entities.packetboxes,
        result: action.payload.result,
      };
    case PACKETBOX_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        current: action.payload,
      };
    case PACKETBOXES_FETCH_ERROR:
    case PACKETBOX_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };

    case PACKETBOX_UNLOAD_CURRENT:
      return {
        ...state,
        current: null,
      };

    case PACKETBOX_MODIFY_SUCCESS:
      return {
        ...state,
        current: action.payload,
      };

    case NOTES_FETCH_SUCCESS: {
      const current = Object.assign({}, state.current);
      if (state.current && state.current.id == action.packetboxId) {
        current.notes = action.payload.entities.notes;
      }
      return {
        ...state,
        current,
      };
    }
    case NOTE_MODIFY_SUCCESS:
    case NOTE_CREATE_SUCCESS: {
      if (!(action.payload && action.payload.id)) {
        return state;
      }

      const current = Object.assign({}, state.current);
      current.notes[action.payload.id] = action.payload;

      return {
        ...state,
        current,
      };
    }
    case PACKETBOX_KEYS_FETCH_SUCCESS: {
      return {
        ...state,
        currentKeys: action.payload.data,
      };
    }

    case PACKETBOX_REGENERETE_TAN_REQUEST: {
      return {
        ...state,
        tanRegenerating: true,
      };
    }
    case PACKETBOX_REGENERETE_TAN_SUCCESS: {
      const newEntities = Object.assign({}, state.entities);
      newEntities[action.payload.id] = action.payload;

      return {
        ...state,
        entities: newEntities,
        tanRegenerating: false,
      };
    }
    case PACKETBOX_REGENERETE_TAN_ERROR: {
      return {
        ...state,
        tanRegenerating: false,
      };
    }
  }

  return state;
}

// Schemas
const packetboxSchema = new schema.Entity('packetboxes');
const notesSchema = new schema.Entity('notes');

// Operations
export function fetchPacketboxes(params) {
  return {
    [CALL_API]: {
      types: [PACKETBOXES_FETCH_REQUEST, PACKETBOXES_FETCH_SUCCESS, PACKETBOXES_FETCH_ERROR],
      promise: httpClient => httpClient.post('/lockers/paketbox', params),
      schema: { data: [packetboxSchema] },
    },
  };
}

// Operations
export function fetchNotes(packetboxId) {
  const params = {
    skip: 0,
    take: 9999,
    filter: {
      filters: [{ field: 'paketbox_id', value: packetboxId, operator: 'eq' }],
      logic: 'and',
    },
    sort: [{ field: 'id', dir: 'desc' }],
  };

  return {
    packetboxId,
    [CALL_API]: {
      types: [NOTES_FETCH_REQUEST, NOTES_FETCH_SUCCESS, NOTES_FETCH_ERROR],
      promise: httpClient => httpClient.post('/paketboxNotes', params),
      schema: { data: [notesSchema] },
    },
  };
}

export function createNote(note) {
  return {
    note,
    [CALL_API]: {
      types: [NOTE_CREATE_REQUEST, NOTE_CREATE_SUCCESS, NOTE_CREATE_ERROR],
      promise: httpClient => httpClient.post('/paketboxNotes/modify', note),
      successMessage: 'Note successfully created',
    },
  };
}

export function modifyNote(note) {
  return {
    note,
    [CALL_API]: {
      types: [NOTE_MODIFY_REQUEST, NOTE_MODIFY_SUCCESS, NOTE_MODIFY_ERROR],
      promise: httpClient => httpClient.post('/paketboxNotes/modify', note),
      successMessage: 'Note successfully modified',
    },
  };
}

export function fetchPacketbox(id) {
  return function (dispatch, getState) {
    const packetboxesState = getState().packetboxes;

    if (packetboxesState.entities && id in packetboxesState.entities) {
      // packetbox already exists in store
      dispatch({ type: PACKETBOX_FETCH_SUCCESS, payload: packetboxesState.entities[id] });
    } else {
      dispatch({
        [CALL_API]: {
          types: [PACKETBOX_FETCH_REQUEST, PACKETBOX_FETCH_SUCCESS, PACKETBOX_FETCH_ERROR],
          promise: httpClient => httpClient.get(`/lockers/paketbox/${id}`),
        },
      });
    }
  };
}

export function unloadCurrentPacketbox() {
  return function (dispatch) {
    dispatch({ type: PACKETBOX_UNLOAD_CURRENT });
  };
}

export function createPacketbox(packetbox) {
  return {
    [CALL_API]: {
      types: [PACKETBOX_CREATE_REQUEST, PACKETBOX_CREATE_SUCCESS, PACKETBOX_CREATE_ERROR],
      promise: httpClient => httpClient.post('/lockers/paketbox/modify', packetbox),
      successMessage: 'Packetbox successfully created',
    },
  };
}

export function modifyPacketbox(packetbox) {
  return {
    [CALL_API]: {
      types: [PACKETBOX_MODIFY_REQUEST, PACKETBOX_MODIFY_SUCCESS, PACKETBOX_MODIFY_ERROR],
      promise: httpClient => httpClient.post('/lockers/paketbox/modify', packetbox),
      successMessage: 'Packetbox successfully modified',
    },
  };
}

export function regenerateTan(id) {
  return {
    [CALL_API]: {
      types: [
        PACKETBOX_REGENERETE_TAN_REQUEST,
        PACKETBOX_REGENERETE_TAN_SUCCESS,
        PACKETBOX_REGENERETE_TAN_ERROR,
      ],
      promise: httpClient => httpClient.get(`/lockers/paketbox/${id}/resetActivationPin`),
      successMessage: 'TAN successfully generated',
    },
  };
}

export function fetchPacketboxKeys(packetboxId) {
  const params = {
    skip: 0,
    take: 9999,
    filter: {
      filters: [
        {
          field: 'paketbox___id',
          value: packetboxId,
          operator: 'eq',
        },
        {
          field: 'valid',
          value: true,
          operator: 'eq',
        },
      ],
      logic: 'and',
    },
    sort: [{ field: 'id', dir: 'desc' }],
  };

  return {
    packetboxId,
    [CALL_API]: {
      types: [
        PACKETBOX_KEYS_FETCH_REQUEST,
        PACKETBOX_KEYS_FETCH_SUCCESS,
        PACKETBOX_KEYS_FETCH_ERROR,
      ],
      promise: httpClient => httpClient.post('/lockers/paketbox/keys', params),
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/packetboxes.js